import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initiaCustomerslFilter } from "../../CustomersUIHelpers";

const CustomersDebtTableUIContext = createContext();

export function useCustomersDebtTableUIContext() {
  let context = useContext(CustomersDebtTableUIContext);
  return context;
}

export const CustomersDebtTableUIConsumer =
  CustomersDebtTableUIContext.Consumer;

export function CustomersDebtTableProvider({
  CustomersDebtTableEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initiaCustomerslFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
  };

  return (
    <CustomersDebtTableUIContext.Provider value={value}>
      {children}
    </CustomersDebtTableUIContext.Provider>
  );
}
